// One-time migration of the old browser-local orderSpy pins into the shared
// server-side pos_pinned_stores table (brief decision 1).
//
// Pins used to live only under this localStorage key, which a nightly server job
// cannot read. On first load we lift any ids the browser still holds into the
// table, then remove the key so the migration runs exactly once per browser.
// Every storage access is wrapped: private browsing throws on read AND write, so
// a throwing localStorage must degrade to "nothing to migrate", never break the
// page.

// Exact legacy key used by the previous useFavoriteStores implementation.
export const LEGACY_FAVORITES_KEY = "mmp_favorite_stores";

/** Reads the ids still held under the legacy key. Returns [] on anything
 *  unreadable (missing key, malformed JSON, or a throwing localStorage). */
export function readLegacyPinIds(): string[] {
  try {
    const raw = localStorage.getItem(LEGACY_FAVORITES_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed)
      ? parsed.filter((x): x is string => typeof x === "string" && x.trim() !== "")
      : [];
  } catch {
    return [];
  }
}

/** Removes the legacy key so the migration cannot run a second time. A throwing
 *  localStorage is swallowed: the worst case is the key lingers and the (now
 *  idempotent, upsert-based) migration re-runs harmlessly next load. */
export function clearLegacyPins(): void {
  try {
    localStorage.removeItem(LEGACY_FAVORITES_KEY);
  } catch {
    // Non-fatal by design.
  }
}
